import { render, staticRenderFns } from "./MessageInfoCard.vue?vue&type=template&id=10337f37&scoped=true&"
import script from "./MessageInfoCard.vue?vue&type=script&lang=js&"
export * from "./MessageInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./MessageInfoCard.vue?vue&type=style&index=0&id=10337f37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10337f37",
  null
  
)

export default component.exports